var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareBranch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -638.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Branch",
    transform: "translate(3498.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,22.6573214 L29,22.6573214 L29,15.4642857 L22,15.4642857 L22,22.6573214 Z M19.528,9.3515 C19.528,11.0272857 18.111,12.3001786 16.24,12.3001786 C14.369,12.3001786 12.952,11.0272857 12.952,9.3515 L12.952,5.80003571 C12.952,4.81714286 13.714,4.01446429 14.663,4.01446429 L14.783,4.01446429 L14.783,9.33803571 C14.783,10.2391071 15.558,10.7911429 16.307,10.7911429 C17.028,10.7911429 17.803,10.2795 17.803,9.33803571 L17.803,5.70371429 C17.803,4.77571429 18.539,4.01446429 19.434,4.01446429 L19.528,4.01446429 L19.528,9.3515 Z M13,27.8928571 L19,27.8928571 L19,15.4642857 L13,15.4642857 L13,27.8928571 Z M3,22.6573214 L10,22.6573214 L10,15.4642857 L3,15.4642857 L3,22.6573214 Z M4,2 C1.791,2 0,3.85496429 0,6.14285714 L0,31 L28,31 C30.209,31 32,29.1450357 32,26.8571429 L32,2 L4,2 Z",
    id: 113
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareBranch);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-branch.10b85936.svg";
export { ForwardRef as ReactComponent };